export default __webpack_public_path__ + "asset/img/icon-arrange-asc~a942abfa.png";